<template>
  <div class="mt20" :key="i18nUpdateKey">
    <div class="flex-a-c mb20">
      <div class="w100 text-align-right mr30">{{ $t('business', 'formModuleName') }}</div>
      <el-input class="w200 textc" 
                v-model="title"
                :placeholder="$t('business', 'contactUs')" 
                maxlength="6"></el-input>
    </div>
    <div class="flex-a-c mb20">
      <div class="w100 text-align-right mr30">{{ $t('business', 'formIntroduction') }}</div>
      <el-input class="w600" 
                type="textarea" 
                v-model="desc" 
                :placeholder="$t('business', 'feedbackPlaceholder')" 
                :autosize="{ minRows: 3, maxRows: 4}"
                maxlength="60"></el-input>
    </div>
    <div class="flex-a-c mb20">
      <div class="w100 text-align-right mr30">{{ $t('business', 'buttonName') }}</div>
      <el-input class="w200 textc" 
                type="text" 
                :placeholder="$t('business', 'submitFeedback')" 
                v-model="button" 
                maxlength="6"></el-input>
    </div>
    <el-button class="v-primary ml10"
                type="primary"
                @click="saveSetting"
                >{{ $t('business', 'publishForm') }}</el-button
              >
  </div>
</template>

<script>

import {
  updateSetting,
  querySetting
} from "@/api/companyManage.js";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  
  data() {
    return {
      title:'',
      button:'',
      desc:''
    };
  },
  mounted(){
    this.querySetting()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  methods: {
    saveSetting(){
      if(!this.title || !this.button || !this.desc){
        return this.$message.error(this.$t('business', 'completeSettings'))
      }
      let data = {
        title:this.title,
        button:this.button,
        state:1,
        desc:this.desc
      }
      updateSetting(data)
      .then(res=>{
        if(res.code == 200){
          this.$message.success(this.$t('business', 'saveSuccess'))
        }else{
          this.$message.error(this.$t('business', 'saveFailed'))
        }
      })
      .catch(err=>{
        // this.$message.error('保存失败')
      })
    },
    querySetting(){
      let data = {
        state:1
      }
      querySetting(data)
      .then(res=>{
        console.log(res)
        if(res.data ){
          this.title = res.data?.title
          this.button = res.data?.button
          this.desc = res.data?.desc
        }
      })
    }
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped>

</style>